import { render, staticRenderFns } from "./BillIcon6.vue?vue&type=template&id=d5cd0bcc&"
import script from "./BillIcon6.vue?vue&type=script&lang=ts&"
export * from "./BillIcon6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports